//console.log('custom-register.js');
$(function(){
  
  // 誕生日：年・月に応じて日の<option>をセット
  $('.js-birth-y, .js-birth-m').change(function(){
    formSetDay();
  });
  function formSetDay(){
    var lastday = formSetLastDay($('.js-birth-y').val(), $('.js-birth-m').val());
    var option = '';
    for (var i = 1; i <= lastday; i++) {
      if (i === $('.js-birth-d').val()){
        option += '<option value="' + i + '" selected="selected">' + i + '</option>n';
      }else{
        option += '<option value="' + i + '">' + i + '</option>n';
      }
    }
    $('.js-birth-d').html(option);
  }
  function formSetLastDay(year, month){
    var lastday = new Array('', 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0){
      lastday[2] = 29;
    }
    return lastday[month];
  }
  
  // 誕生日：最終結果
  $('.js-birth-y, .js-birth-m, .js-birth-d').change(function(){
    var val_y = $('.js-birth-y').val();
    var val_m = ( '00' + $('.js-birth-m').val() ).slice( -2 );
    var val_d = ( '00' + $('.js-birth-d').val() ).slice( -2 );
    $('.js-birth-result').val(val_y+'-'+val_m+'-'+val_d);
  });
  
  // 個人情報の取り扱いに同意
  $('.js-privacy-clickable').click(function(){
    $('.js-privacy-input').prop('checked', !$('.js-privacy-input').prop('checked'));
    if($('.js-privacy-input').prop('checked')){
      $('.js-submit').removeAttr('disabled');
    }else{
      $('.js-submit').attr('disabled', 'disabled');
    }
  });
  $('.js-privacy-input').change(function() {
    if($('.js-privacy-input').prop('checked')){
      $('.js-submit').removeAttr('disabled');
    }else{
      $('.js-submit').attr('disabled', 'disabled');
    }
  });
  
});